import api from './api';
import {
  ApiTokenResponse, CreateApiTokenRequest, CreatedApiTokenResponse,
} from '../types';

export const apiTokenService = {
  getAll: async (): Promise<ApiTokenResponse[]> => {
    const response = await api.get('/api-tokens');
    return response.data;
  },

  create: async (data: CreateApiTokenRequest): Promise<CreatedApiTokenResponse> => {
    const response = await api.post('/api-tokens', data);
    return response.data;
  },

  revoke: async (id: number): Promise<void> => {
    await api.delete(`/api-tokens/${id}`);
  },
};

export default apiTokenService;
